import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarehouseLocalizationDetailsFormComponent } from '../../components/warehouse-localization-details-form/warehouse-localization-details-form.component';
import { WarehouseLocalizationDataSourceService } from '../../services/warehouse-localization-data-source.service';
import { Observable } from 'rxjs';
import { WarehouseLocalizationDetailsForm } from '../../models/warehouse-localization-details-form';
import { Guid, once } from '@web/utils';
import { SpinnerFilledComponent } from '@web/shared/ui';

@Component({
  selector: 'app-warehouse-localization-edit',
  imports: [
    CommonModule,
    WarehouseLocalizationDetailsFormComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './warehouse-localization-edit.component.html',
  styleUrl: './warehouse-localization-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseLocalizationEditComponent {
  /* prettier-ignore */
  private readonly warehouseDataSource = inject(WarehouseLocalizationDataSourceService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly id = input.required<Guid>();
  public readonly submitSuccessEvent = output();

  protected data$!: Observable<WarehouseLocalizationDetailsForm>;

  public constructor() {
    effect(() => this.configureDataSource());
  }

  protected handleSubmitClickEvent(
    data: WarehouseLocalizationDetailsForm,
  ): void {
    this.warehouseDataSource
      .updateByFromData(this.id(), data)
      .pipe(once())
      .subscribe(() => {
        this.notifySubmitSuccessEvent();
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private configureDataSource(): void {
    this.data$ = this.warehouseDataSource.fetchDetailsFormById(this.id());
    this.changeDetectorRef.detectChanges();
  }
}
